import React, {useContext} from 'react';
import styled from 'styled-components';
import {ThemeContext} from '../styles/ThemeContext';
import {UserContext} from '../contexts/UserContext';
import {AvatarType} from './AvatarType';
import DhlText from './DhlText';
import { useTranslation } from 'react-i18next';
// import {DhlImage} from "@dhl-official/ui-libraries/react-library";
// import {IconContext} from "../../../assets/IconContext";

const Wrapper = styled.div<{ isSmall: boolean }>`
  width: ${(props) => (props.isSmall ? '30px' : '150px')};
  height: ${(props) => (props.isSmall ? '30px' : '150px')};
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 4px;
  border-radius: ${(props) => (props.isSmall ? '15px' : '75px')};
  background-color: ${(props) => props.theme.color.grey[500]};
`;

const LoadingSkeleton = styled.div<{ isSmall: boolean }>`
  width: ${(props) => (props.isSmall ? '30px' : '150px')};
  height: ${(props) => (props.isSmall ? '30px' : '150px')};
  border-radius: 50%;
  background: linear-gradient(
    90deg,
    ${(props) => props.theme.color.grey[300]} 25%,
    ${(props) => props.theme.color.grey[200]} 50%,
    ${(props) => props.theme.color.grey[300]} 75%
  );
  background-size: 200% 100%;
  animation: loading 1.5s ease-in-out infinite;

  @keyframes loading {
    0% {
      background-position: 200% 0;
    }
    100% {
      background-position: -200% 0;
    }
  }
`;

const AvatarPicture = styled.img<{ $isSmall: boolean }>`
    height: ${(props) => (props.$isSmall ? '30px' : '150px')};
    width: ${(props) => (props.$isSmall ? '30px' : '150px')};
    border-radius: 50%;
    object-fit: cover;
`

// const EditPicture = styled(DhlImage)`
//     height: 40px;
//     width: 40px;
//     position: relative;
//     top: 30%;
//     left: -17%;
//     cursor: pointer;
// `

const Avatar: React.FC<AvatarType> = (props) => {
    const { t } = useTranslation();
    const {theme} = useContext(ThemeContext);
    const {user, isAvatarLoading} = useContext(UserContext);
    // const {getIcon} = useContext(IconContext);
    let MyPlaceHolder = "AB";

    if(user !== undefined || props.userName !== undefined) {
        MyPlaceHolder = `${Array.from(props?.userName !== undefined ? props.userName.firstName : user.firstName)[0]}${
            Array.from(props?.userName !== undefined ? props.userName.lastName : user.lastName)[0]
        }`;
    }


    if(MyPlaceHolder === "undefinedundefined") {
        MyPlaceHolder = "AB"
    }

    const {isSmall = false} = props;

    return (
        <>
            {/* Show loading skeleton while avatar is being fetched */}
            {isAvatarLoading && (props.noAvatar !== true) && (
                <LoadingSkeleton theme={theme} isSmall={isSmall} />
            )}

            {/* Show initials when avatar is not loading and either no avatar exists or noAvatar prop is set */}
            {!isAvatarLoading && (user.avatar == null || (props.noAvatar ?? false)) && (
                <Wrapper theme={theme} isSmall={isSmall}>
                    <DhlText
                        size={isSmall ? 'sm' : 'heading4'}
                        weight={800}
                        color={'#ffffff'}
                        title={MyPlaceHolder.toUpperCase()}
                    />
                </Wrapper>
            )}

            {/* Show avatar image when loading is complete and avatar exists */}
            {!isAvatarLoading && user.avatar != null && !(props.noAvatar ?? false) && (
                <AvatarPicture
                  src={URL.createObjectURL(user.avatar)}
                  $isSmall={isSmall}
                  alt={t('App.page.profile.pictureAltText', { defaultValue: 'Profile Picture' }) ?? undefined}
                />
            )}

            {/* {!isSmall && <EditPicture src={getIcon('RedPencil')}/>} */}
        </>
    );
};

export default Avatar;
